import type { HTMLAttributes } from "react";

import { cn } from "products/muggleTestV0/lib/utils";

interface SectionProps extends HTMLAttributes<HTMLElement> {
  id?: string;
}

interface SectionHeaderProps extends HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
  titleClassName?: string;
  descriptionClassName?: string;
}

export function Section({ className, ...props }: SectionProps) {
  return (
    <section
      className={cn(
        "border-b border-border/40",
        "scroll-mt-16",
        "min-h-fit lg:min-h-[50vh] xl:min-h-[45vh]",
        className
      )}
      {...props}
    />
  );
}

export function SectionHeader({
  title,
  description,
  className,
  titleClassName,
  descriptionClassName,
  ...props
}: SectionHeaderProps) {
  return (
    <div className={cn("mb-8 text-center sm:mb-10", className)} {...props}>
      <h2 className={cn("mb-4 text-pretty text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl", titleClassName)}>
        {title}
      </h2>
      {description ? (
        <p className={cn("mx-auto max-w-2xl text-pretty text-lg text-muted-foreground", descriptionClassName)}>
          {description}
        </p>
      ) : null}
    </div>
  );
}
